import React from "react";
import { Formik, Form, Field } from "formik";
import l from "components/util/l";

const CloneForm = ({ 
  onClickCloneCollection = () => { },
  onClose = () => { },
}) => {

  return <div className="card">

    <div class="card-header">
      <h3 class="mb-0">
        {l("Duplicar tabla%CA063")}
      </h3>
    </div>
    <div class="card-body py-4">
      <Formik
        initialValues={{}}
        onSubmit={(values) => {
          onClickCloneCollection(values);
          onClose();
        }}
      >
        {({ values, setFieldValue }) =>
          <Form>

            <div className="w-100 mb-2">
              <div className="d-flex justify-content-start align-items-center">
                <h6 className="m-0 p-0" style={{ color: "#777" }}>
                  {l("Mantener registros%CA064")}
                </h6>
                <Field
                  type="checkbox"
                  className="from-control ml-2"
                  name="clone_data"
                />
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <button
                type="submit"
                class="btn btn-block btn-primary mt-3"
              >
                {l("Duplicar%CA065")}
              </button>

            </div>

          </Form>}
      </Formik>
    </div>
  </div>
}

export default CloneForm;